package com.exura.features.plandefinition.data.serialization

import com.exura.features.plandefinition.data.remote.dto.series.BaseSeriesDto
import com.exura.features.plandefinition.data.remote.dto.series.SimpleFloatingSeriesDto
import com.exura.features.plandefinition.data.remote.dto.series.SimpleInstructionSeriesDto
import com.exura.features.plandefinition.data.remote.dto.series.SimplePersistentSeriesDto
import com.exura.features.plandefinition.data.remote.dto.series.SimpleQuestionSeriesDto
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass

/**
 * Serializers module specifically for series-related DTOs
 */
val collectionSerializersModule = SerializersModule {
}
